import { useId } from 'react';
import clsx from 'clsx';
import { useDropdownFlip, useDropdownMenu } from '../../../../shared/hooks';
import { MaximizeIcon, MinimizeIcon } from '../../../../shared/ui/icons';
import { IconButton } from '../../../../shared/ui/icon-button/IconButton';
import scrollbarStyles from '../../../../shared/styles/scrollbarThin.module.css';
import styles from './TemplateWarnings.module.css';

const WARNINGS_SUMMARY = 'Client data missing in the WayThru account';
const MAX_VISIBLE_WARNINGS = 5;

export function TemplateWarnings({ warnings = [] }) {
  const listId = useId();
  const { rootRef, open, toggleOpen } = useDropdownMenu();
  const { dropdownRef, openUpward } = useDropdownFlip(open);
  const needsScroll = warnings.length > MAX_VISIBLE_WARNINGS;

  if (warnings.length === 0) {
    return null;
  }

  if (warnings.length === 1) {
    return (
      <div className={clsx(styles.banner)}>
        <div className={clsx(styles.header)}>
          <p className={clsx(styles.text)}>{warnings[0]}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={clsx(styles.root)} ref={rootRef}>
      <div className={clsx(styles.banner)}>
        <div className={clsx(styles.header)}>
          <span className={clsx(styles.text)}>
            [{warnings.length}] {WARNINGS_SUMMARY}
          </span>
          <IconButton
            ariaLabel={open ? 'Hide warnings' : 'Show warnings'}
            className={clsx(styles.toggleButton)}
            variant="plain"
            onClick={toggleOpen}
            aria-expanded={open}
            aria-controls={open ? listId : undefined}
          >
            {open ? <MinimizeIcon /> : <MaximizeIcon />}
          </IconButton>
        </div>
      </div>
      {open && (
        <div
          id={listId}
          ref={dropdownRef}
          className={clsx(
            styles.popover,
            openUpward && styles.popoverUp,
            needsScroll && styles.popoverScrollable,
          )}
        >
          <ul
            style={needsScroll ? { '--warnings-visible-rows': MAX_VISIBLE_WARNINGS } : undefined}
            className={clsx(
              styles.list,
              needsScroll && styles.listScroll,
              needsScroll && scrollbarStyles.scrollbarThinY,
              needsScroll && scrollbarStyles.overscrollContain,
            )}
          >
            {warnings.map((warning, i) => (
              <li key={`${warning}-${i}`} className={clsx(styles.popoverItem)}>
                {warning}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
